<script setup lang="ts">
import type { BookmarkItem } from '@/types'

defineProps<{
  isOpen: boolean
  bookmarks: BookmarkItem[]
  totalBookmarks: number
  totalFolders: number
  lastSync: string | null
}>()

const emit = defineEmits<{
  'toggle': []
  'navigate': [bookmark: BookmarkItem]
}>()

function formatDate(timestamp: number | null): string {
  if (!timestamp) return '-'
  return new Date(timestamp).toLocaleString('zh-CN')
}
</script>

<template>
  <aside
    class="sidebar bg-sidebar border-r border-sidebar-border transition-all duration-300"
    :class="isOpen ? 'w-64' : 'w-0 overflow-hidden'"
  >
    <div class="flex flex-col h-full">
      <div class="sidebar-header flex items-center justify-between p-4 border-b border-sidebar-border">
        <h3 class="text-sidebar-foreground font-semibold">快速访问</h3>
        <button class="btn-icon" @click="emit('toggle')">
          <i class="fas fa-chevron-left"></i>
        </button>
      </div>

      <div class="sidebar-content flex-1 overflow-y-auto p-4">
        <div class="quick-access space-y-2">
          <div
            v-for="bookmark in bookmarks"
            :key="bookmark.id"
            class="quick-access-item p-3 rounded-lg cursor-pointer transition-colors hover:bg-sidebar-accent"
            @click="emit('navigate', bookmark)"
          >
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 rounded-full bg-sidebar-primary flex items-center justify-center text-sidebar-primary-foreground">
                <i :class="bookmark.isFolder ? 'fas fa-folder' : 'fas fa-bookmark'"></i>
              </div>
              <span class="text-sidebar-foreground text-sm truncate">{{ bookmark.name }}</span>
            </div>
          </div>
        </div>

        <div class="stats mt-8 p-4 bg-sidebar-accent rounded-lg">
          <h4 class="text-sidebar-foreground font-semibold mb-3 text-sm">统计信息</h4>
          <div class="space-y-2 text-sm">
            <div class="flex justify-between text-sidebar-foreground">
              <span>总书签数:</span>
              <span class="font-medium">{{ totalBookmarks }}</span>
            </div>
            <div class="flex justify-between text-sidebar-foreground">
              <span>文件夹数:</span>
              <span class="font-medium">{{ totalFolders }}</span>
            </div>
            <div class="flex justify-between text-sidebar-foreground">
              <span>最后同步:</span>
              <span class="font-medium text-xs">{{ formatDate(lastSync) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>
